<div class="proposal-header">
  <h2 mat-dialog-title class="proposal-title">Proposition de l’IA</h2>
  <p class="proposal-subtitle">
    Relisez le texte proposé. En l’insérant, il remplacera le contenu actuel de la
    recommandation, que vous pourrez encore modifier.
  </p>
</div>
<div mat-dialog-content class="proposal-body">
  <div class="proposal-content" [innerHTML]="data.html"></div>
</div>
<div mat-dialog-actions class="proposal-actions">
  <pr-button
    display="neutral"
    variant="outline"
    label="Ne pas insérer"
    [mat-dialog-close]="false"
  />
  <pr-button display="neutral" variant="filled" label="Insérer" [mat-dialog-close]="true" />
</div>
